"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionTitle = void 0;
var react_1 = __importDefault(require("react"));
var Context_1 = require("../../../domains/billing/components/Context");
var TransactionTitle = function (_a) {
    var description = _a.description, context = _a.context;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        description,
        " ",
        context ? react_1.default.createElement(Context_1.Context, { contexts: [context] }) : null));
};
exports.TransactionTitle = TransactionTitle;
